<template>
  <div class="meter-device-list">

    <template v-if="withControl">
      <v-row v-if="currentUser.permissions.includes('OPERATOR_WRITE')">
        <v-col class="text-right">
          <v-btn small :to="{name: 'meter-device.add'}">
            <v-icon left>mdi-plus</v-icon>
            {{ $t('meter-device.add') }}
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <v-row align="center">
      <v-col>
        <search-field
            :placeholder="$t('meter-device.search-placeholder')"
            :search.sync="search"
            clearable
        />
      </v-col>
      <!-- Réservé à l'opérateur, comme le filtre équivalent sur les bornes. Posé dans une
           colonne auto à côté de la recherche : la rangée garde sa hauteur et l'écran des
           clients est strictement inchangé. -->
      <v-col cols="auto" v-if="currentUser.isZE">
        <v-checkbox
            :label="$t('meter-device.without-licence')"
            v-model="withoutLicence"
            hide-details
            class="mt-0 pt-0"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-10">
      <v-col>
        <v-data-table
            class="cp-list"
            :headers="headers"
            :items="items"
            :loading="loading"
            :options.sync="options"
            :server-items-length="total"
        >

          <template #item.type="{item}">
            {{ $t(`enums.meter-device.${item.type}`) }}
          </template>
          <template #item.hasActiveLicence="{item}">
            <v-tooltip bottom v-if="item.hasActiveLicence === false">
              <template #activator="{ on, attrs }">
                <v-icon small color="warning" v-bind="attrs" v-on="on">mdi-alert</v-icon>
              </template>
              {{ $t('meter-device.no-active-licence') }}
            </v-tooltip>
          </template>
          <template #item.name="{item}">
            <router-link :to="{name: 'meter-device.detail', params: {id: item.id}}">
              <span class="identifier">{{ item.name }}</span>
            </router-link>
          </template>
          <template #item.customer="{item}">
            {{ customerName(item.customer) }}
          </template>

        </v-data-table>
      </v-col>
    </v-row>


  </div>
</template>

<script>


import MeterDeviceRepository from "@repository/MeterDeviceRepository";

export default {
  components: {},
  data() {
    return {
      loading: false,
      search: null,
      withoutLicence: false,
      items: [],
      total: 0,
      options: null,

    }
  },

  props: {
    organizationId: String,
    locationId: String,
    withControl: Boolean,
    loaded: Boolean,
    count: Number,
  },

  mounted() {
    if (!this.currentUser.permissions.includes('OPERATOR_READ')) {
      this.$router.replace({name: 'dashboard'})
      return
    }

    this.$emit('update:count', 0)
    this.$emit('update:loaded', false)
  },

  watch: {
    withoutLicence() {
      this.options.page = 1
      this.searchData()
    },

    search(val) {
      if (this.options.page > 1) {
        this.options.page = 1
      } else {
        this.searchData()
      }
    },

    options(val) {
      this.searchData()
    }
  },

  computed: {
    headers() {
      return [
        {text: '', value: 'hasActiveLicence', sortable: false, width: 32},
        {text: this.$t('organization.organization'), value: 'organization.name'},
        {text: this.$t('name'), value: 'name'},
        {text: this.$t('meter-device.type'), value: 'type'},
        {text: this.$tc('customer.customer', 1), value: 'customer'},
      ]
    },

  },

  methods: {
    customerName(customer) {
      if(customer) {

        if(customer.name) {
          return customer.name
        }
        let names = []
        if(customer.firstname) {
          names.push(customer.firstname)
        }

        if(customer.lastname) {
          names.push(customer.lastname)
        }
        if(names.length > 0) {
          return names.join(' ')
        }

        if(customer.evcoId) {
          return customer.evcoId
        }
      }
      return 'no name'
    },


    searchData() {

      let options = this.options


      let query = this.search;
      let offset = options.itemsPerPage * options.page - options.itemsPerPage;
      let limit = options.itemsPerPage;
      let orderBy = options.sortBy.length > 0 ? options.sortBy[0] : 'name'
      let orderDirection = options.sortDesc.length > 0 && options.sortDesc[0] ? 'desc' : 'asc'


      const data = {
        query: query,
        offset: offset,
        limit: limit,
        orderBy: orderBy,
        orderDirection: orderDirection,
      }
      if (this.withoutLicence) {
        data.withoutLicence = true
      }
      if (this.organizationId) {
        data.organizationId = this.organizationId
      }
      if (this.locationId) {
        data.locationId = this.locationId
      }

      this.loading = true
      MeterDeviceRepository.search(data).then(result => {
        this.total = result.total
        this.items = result.items
        this.loading = false
        this.$emit('update:count', this.total)
        this.$emit('update:loaded', true)
      }).catch(err => {
        this.notifyError(err)
        this.loading = false
      })
    },


  }
}
</script>

<style lang="scss">
.meter-device-list {

}


</style>
